import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    baseUrl: window.location.protocol + '//' + window.location.host,
    userName: "",
    userData: null,
    /** Non-null when GET /api/me failed after login; message for the user */
    userDataLoadError: null,
    isAuthenticated: false,
    userMenu: [],
    org: {
      portalName: null,
      logoUrl: null,
      logoUrlDark: null,
      faviconUrl: null,
      primaryColor: null,
      secondaryColor: null,
      accentColor: null
    }
  },
  mutations: {
    setUserData(state, userData) {
      // userData contains:
      // email, firstName, lastName, name, organisation, permissions, roles,
      // userId
      state.userData = userData
    },
    setUserDataLoadError(state, message) {
      state.userDataLoadError = message
    },
    setUserMenu(state, menu) {
      state.userMenu = menu
    },
    setOrgConfig(state, config) {
      state.org.portalName = config.portalName
      state.org.logoUrl = config.logoUrl
      state.org.logoUrlDark = (config.logoUrlDark !== undefined) ? config.logoUrlDark : null
      state.org.faviconUrl = config.faviconUrl
      state.org.primaryColor = config.primaryColor
      state.org.secondaryColor = config.secondaryColor
      state.org.accentColor = config.accentColor
    },
  }
})

export default store